/**
 * The words on an introduction portal, as pure functions.
 */

/** The header of the viewer. */
export function introCopy({ name, own, place, days }) {
  const first = (name || '').trim().split(' ')[0];
  const left = `${days} ${days === 1 ? 'DAY' : 'DAYS'} LEFT`;
  return {
    title: own ? 'YOUR INTRODUCTION' : `${first.toUpperCase()}’S INTRODUCTION`,
    sub: ['A PORTAL', place ? place.toUpperCase() : null, left].filter(Boolean).join(' · '),
  };
}

const WEEKDAYS = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

/** TODAY, a weekday inside the last week, else OCT 12. */
export function joinedLabel(iso, now = new Date()) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'RECENTLY';
  const startOf = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const daysAgo = Math.round((startOf(now) - startOf(d)) / 86400000);
  if (daysAgo <= 0) return 'TODAY';
  if (daysAgo < 7) return WEEKDAYS[d.getDay()];
  return `${MONTHS[d.getMonth()]} ${d.getDate()}`;
}

/** "LISA, KIMMY + 10 MORE OF YOUR FRIENDS KNOW THEM". Null when there are none. */
export function mutualLine(names = [], count = 0) {
  if (!count) return null;
  const shown = names.slice(0, 2).map((n) => n.trim().split(' ')[0].toUpperCase());
  if (!shown.length) return `${count} OF YOUR FRIENDS ${count === 1 ? 'KNOWS' : 'KNOW'} THEM`;
  const more = count - shown.length;
  if (more > 0) return `${shown.join(', ')} + ${more} MORE OF YOUR FRIENDS KNOW THEM`;
  return `${shown.join(', ')} ${count === 1 ? 'KNOWS' : 'KNOW'} THEM`;
}

/**
 * Handles to offer someone who never picked one (sign-up does not ask), best first: the name
 * squeezed, split by an underscore, first name + initial, initial + last name, the first name, then
 * numbered. The API's availability check decides which are shown.
 */
export function handleCandidates(name, tries = 8) {
  const words = (name || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().split(/\s+/)
    .map((w) => w.replace(/[^a-z0-9]/g, '')).filter(Boolean);
  const base = words.join('').slice(0, 26);
  if (base.length < 3) return [];
  const [first, last] = [words[0], words[words.length - 1]];
  const out = [base];
  if (words.length > 1) out.push(words.join('_').slice(0, 26), `${first}${last[0]}`, `${first[0]}${last}`, first);
  for (let n = 2; new Set(out).size < tries; n += 1) out.push(`${base}${n}`);
  return [...new Set(out)].filter((h) => h.length >= 3).slice(0, tries);
}
